import React, { useEffect, useState } from "react";
import { ReactComponent as AddTask } from "../../svg/AddTaskSvg.svg";
import AddBox from "./AddBox";
import { FiEdit } from "react-icons/fi";
import { BsFillCaretDownFill } from "react-icons/bs";
import ComponentHeader from "./ComponentHeader";
import BasicList from "./ListSelector";
import Popover from "@mui/material/Popover";
import { forwardRef } from "react";
import ReactDatePicker from "react-datepicker";
import Taskchip from "./Taskchip";
import MenuButton from "./MenuButton";
import { AddReminder, getReminder } from "../../services/ReminderService";
import DashModal from "./DashModel";
import ReminderAdd from "./ReminderAdd";
import { toastMsg } from "../../Utils/AllConstant";
import { showToastError, showToastSuccess } from "../../Utils/Helper";
import moment from "moment";
import TaskAdd from "./TaskAdd";
import { useDateTimezone } from "../../Context/DateTimezoneContext";

function Dash_Tasks() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [calFilter, setCalFilter] = useState(new Date());
  const [reminders, setReminders] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [label, setLabel] = useState("Current");
  const [data, setData] = useState(0);
  const [updates, setUpdates] = useState([]);
  const { dashboardDate } = useDateTimezone()

  useEffect(() => {
    setCalFilter(dashboardDate)
  }, [dashboardDate]);

  const fetchReminderData = async (date) => {
    const data = await getReminders(moment(new Date(date)).format("YYYY-MM-DD"));
    setUpdates(data?.sort(function (a, b) {
      return order[a.priority] - order[b.priority];
    }));
    return data
  }

  useEffect(() => {
    fetchReminderData(calFilter)
  }, [calFilter]);

  const handleReminder = async (e, task) => {
    e.preventDefault();
    var parms = {};
    parms["typeId"] = task._id;
    parms["isCompleted"] = task.isCompleted.includes(
      moment(new Date(calFilter)).format("YYYY-MM-DD")
    )
      ?
      task.isCompleted.filter((date) => moment(new Date(date)).format("YYYY-MM-DD") !== moment(new Date(calFilter)).format("YYYY-MM-DD")).map(date => date)

      : [...task.isCompleted, moment(new Date(calFilter)).format("YYYY-MM-DD")];
    try {
      const response = await AddReminder(parms);
      if (response.status === 200) {
        showToastSuccess(`${task?.type} Updated`);
        getReminders(moment(new Date(calFilter)).format("YYYY-MM-DD"));
      } else {
        showToastError(
          response?.data || response.message || toastMsg.errorMssg
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error?.data?.message || toastMsg.errorMssg
      );
    }
  };

  const [sopen, setOpen] = React.useState({
    status: false,
    modal: "",
  });

  const order = { High: 1, Medium: 2, Low: 3 };

  //get Reminder
  // console.log(updates);
  const getReminders = async (date) => {
    try {
      const response = await getReminder(date);
      if (response.status === 200) {
        if (response?.data?.data !== 'No Data Found') {
          const data = response?.data?.data
          setReminders(() =>
            data?.filter(
              (reminder) => reminder.type === "reminder"
            )
          );
          setTasks(() =>
            data?.filter((task) => task.type === "task")
          );
          return data
        } else {
          setUpdates([]);
          setReminders([]);
          setTasks([]);
        }
      }
    } catch (error) {
      setReminders([]);
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
    }
  };
  // console.log(reminders, "reminder");
  // console.log(tasks, "task");
  // Option Popover
  const handleClick = (event) => {
    // console.log(event);
    setAnchorEl(event.currentTarget);
  };

  // close Popover
  const handleClose = () => {
    fetchReminderData(calFilter)
    setAnchorEl(null);
  };


  const handleDashClick = (modal, status) => {
    console.log(modal, status, "inside");
    setOpen({
      ...sopen,
      status: status,
      modal: modal,
    });
  };

  const handleDashClose = (modal, status) => {
    
    setOpen({
      ...sopen,
      status: status,
      modal: modal,
    });
  };

  const open = Boolean(anchorEl);
  const id =
    open === "simple-popover"
      ? "simple-popover"
      : open === "basic-menu"
        ? "basic-menu"
        : undefined;

  // Calander DropDown
  const CustomDatePicker = forwardRef(({ value, onClick }, ref) => (
    <div className="d-flex align-items-center gap-1">
      {/* <span className="fw-semibold ms-2" style={{ fontSize: "18px", color:'rgba(31, 126, 120, 1)' }}>
        {(new Date(value).getDate() === new Date().getDate()
          ? "Today"
          : value) || "Today"}
      </span> */}
      <button className="btn" onClick={onClick} ref={ref}>
        {/* <span>{value}</span> */}
        <BsFillCaretDownFill color="rgba(31, 126, 120, 1)" />
      </button>
    </div>
  ));
  // console.log(moment(new Date(calFilter)).format("YYYY-MM-DD"));

  // Calander DropDown
  // const DateFilter = forwardRef(({ value, onClick }, ref) => (
  //   <button className="btn" onClick={onClick} ref={ref}>
  //     <span className="fw-bold me-2" style={{ fontSize: "18px" }}>
  //       {(new Date(value).getDate() === new Date().getDate()
  //         ? "Today"
  //         : value) || "Today"}
  //     </span>
  //     <span>
  //       <AiOutlineDown />
  //     </span>
  //   </button>
  // ));

  return (
    <>
      <ComponentHeader //Includes Component Name and Filtering options
        title={"Updates"}
        filter={
          <ReactDatePicker
            dateFormat="MM-dd-yyyy"
            selected={calFilter}
            className="description_inputf mb-0"
            // minDate={new Date("01-01-1720")}
            // maxDate={new Date()}
            showMonthDropdown
            showYearDropdown
            yearDropdownItemNumber={300}
            scrollableYearDropdown
            onChange={(date) => setCalFilter(date)}
            customInput={<CustomDatePicker />}
            placeholderText="mm-dd-yyyy"
          />
        }
        descript={
          <>
            <FiEdit
              size={"24px"}
              aria-describedby={id}
              color="rgba(31, 126, 120, 1)"
              onClick={handleClick}
            />{" "}
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <BasicList
                getReminders={() => getReminders()}
                tasks={tasks}
                setTasks={setTasks}
                reminders={reminders}
                setReminders={setReminders}
              />
            </Popover>
            <span>
              {moment(new Date(calFilter)).format("MM-DD-YYYY") ===
                moment(new Date()).format("MM-DD-YYYY")
                ? "Today"
                : moment(new Date(calFilter)).format("MM-DD-YYYY")}
            </span>
          </>
        }
      />
      {updates?.length > 0 ? (
        <>
          {/* Modal */}
          {sopen.status && (
            <DashModal
              title={sopen.modal === "task" ? "Task" : "Reminder"}
              open={sopen}
              handleClick={handleDashClick}
              content={
                sopen.modal === "task" ? (
                  <TaskAdd
                    data={data}
                    tasks={tasks}
                    getTasks={getReminders}
                    handleClose={() => handleDashClose("", false)}
                  />
                ) : (
                  <ReminderAdd
                    data={data}
                    getReminders={getReminders}
                    reminders={reminders}
                    handleClose={() => handleDashClose("", false)}
                  />
                )
              }
            />
          )}

          {/* List */}
          {/* <div
            style={{ height: "54px" }}
            className="shadow rounded-4 mb-3 px-3 fs-5 fw-semibold  d-flex align-items-center"
          >
            <ReactDatePicker
              dateFormat="MM-dd-yyyy"
              selected={calFilter}
              className="description_inputf mb-0 "
              minDate={new Date("01-01-1720")}
              // maxDate={new Date()}
              showMonthDropdown
              showYearDropdown
              yearDropdownItemNumber={300}
              scrollableYearDropdown
              onChange={(date) => setCalFilter(date)}
              customInput={<DateFilter />}
              placeholderText="mm-dd-yyyy"
            />
          </div> */}
          <MenuButton //Button Option Completed Current
            list={["Completed", "Current"]}
            label={label}
            setLabel={setLabel}
          />
          <div
            style={{
              height: "284px",
              overflowY: updates?.length >= 3 ? "scroll" : "hidden",
              overflowX: "hidden",
            }}
            className={reminders?.length > 0 ? "Dash px-2" : "px-2"}
          >
            {updates.map((task) => {
              if (label.includes("Current")) {
                return (
                  !task.isCompleted?.includes(
                    moment(new Date(calFilter)).format("YYYY-MM-DD")
                  ) && (
                    <Taskchip
                      id={task?._id}
                      type={task?.type}
                      label={task?.title}
                      priority={task?.priority}
                      isChecked={task?.isCompleted?.includes(moment(new Date(calFilter)).format("YYYY-MM-DD"))}
                      onClick={(e) => {
                        handleReminder(e, task);
                      }}
                      onEdit={(title, bool) => {
                        handleDashClick(title, bool);
                        setData(task);
                      }}
                      getReminders={() =>
                        getReminders(
                          moment(new Date(task?.createdAt)).format("YYYY-MM-DD")
                        )
                      }
                    />
                  )
                );
              } else if (label.includes("Completed")) {
                return (
                  task.isCompleted?.includes(
                    moment(new Date(calFilter)).format("YYYY-MM-DD")
                  ) && (
                    <Taskchip
                      type={task?.type}
                      label={task?.title}
                      priority={task?.priority}
                      isChecked={task?.isCompleted?.includes(moment(new Date(calFilter)).format("YYYY-MM-DD"))}
                      onClick={(e) => {
                        handleReminder(e, task);
                      }}
                    />
                  )
                );
              } else {
                return <h4 className=" headFont ">Yeaaa, You have completed all your tasks</h4>;
              }
            })}
          </div>
          {/* <>
          <h5 className="px-3" style={{ color: "rgba(87, 87, 87, 1)" }}>
            Current Tasks
          </h5>
          <Taskchip
            label={"Add new care plan for 5 patient"}
            priority={"High"}
          />
          <Taskchip
            label={"Detox program is about to end today"}
            priority={"Low"}
          />
          <h5 className="px-3" style={{ color: "rgba(87, 87, 87, 1)" }}>
            Completed Tasks
          </h5>
          <Taskchip
            label={"Detox program is about to end today"}
            priority={""}
            isChecked={true}
          />
          <Taskchip
            label={"Detox program is about to end today"}
            priority={""}
            isChecked={true}
          />
          </> */}
        </>
      ) : (
        <div
          style={{ height: "339px" }}
          className="shadow rounded-4 mb-5 d-flex align-items-center"
        >
          <AddBox
            svg={<AddTask />}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "transparent",
              textAlign: "center",
              width: "400px",
            }}
            header="No Updates yet."
            header2=" Click here to add new reminder or tasks."
            content={""}
            handleClick={handleClick}
          />
        </div>
      )}
    </>
  );
}

export default Dash_Tasks;
